import React from "react";
import "./Message.css";
import ReactEmoji from "react-emoji";

const Message = ({ message, name }) => {
  let isSentByCurrentUser = false;
  let trimedName = name.trim().toLowerCase();
  if (message.user == trimedName) {
    isSentByCurrentUser = true;
  }

  return isSentByCurrentUser ? (
    <div className="message-container justify-end">
      <p className="message-user pr-1">{trimedName}</p>
      <div className="message-box bg-blue">
        <p className="message-text white">{ReactEmoji.emojify(message.text)}</p>
      </div>
    </div>
  ) : (
    <div className="message-container justify-start">
      <div className="message-box bg-light">
        <p className="message-text dark">{ReactEmoji.emojify(message.text)}</p>
      </div>
      <p className="message-user pl-1">{message.user}</p>
    </div>
  );
};

export default Message;
